import { combineReducers } from "@reduxjs/toolkit";

// App Reducers
import { globalReducer } from "./features/globalSlice";
import { authReducer } from "./features/authSlice";
import { reportsReducer } from "./features/reportSlice";
import { cartReducer } from "./features/cartSlice";
import { searchReducer } from "./features/searchSlice";
import { employerReducer } from "./features/employerSlice";
import { wpsGenerateSalaryReducer } from "./features/wpsGenerateSalarySlice";

export default combineReducers({
  auth: authReducer,
  global: globalReducer,
  reports: reportsReducer,
  cart: cartReducer,
  search: searchReducer,
  employer: employerReducer,
  wpsGenerateSalary: wpsGenerateSalaryReducer,
});
